/**
 * Makes a array from start to end number, including both numbers.
 * @param startNumber starting number of the array, including this number.
 * @param endNumber ending number of the array, including this number.
 */
export const makeRange = (startNumber, endNumber) => {
    const result = new Array();
    for (let index = startNumber; index <= endNumber; index++) {
        result.push(index);
    }
    return result;
};
export const sumArray = (numbers) => numbers.reduce((sum, number) => sum + number, 0);
export const multiplyArray = (numbers) => numbers.reduce((product, number) => product * number, 1);
export const factorial = (number) => {
    const numbersToMultiply = makeRange(1, number);
    return multiplyArray(numbersToMultiply);
};
//# sourceMappingURL=mathUtils.js.map